<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myclass" id="نرجسية"><div class="section level2" id="narcissistic" style="padding-top:130px">
<p><span dir="rtl">لا تلعب مع الشيطان فتذهب إلى الجحيم.</span></p><br/><br/>
<p style="text-align:center; direction:ltr">Don’t mess up with Satan, you may go to hell.</p><br/>
<p><span dir="rtl">الأمر مشابه إلى "ألم تخبرك والدتك ألا تلعب بالنار!"</span></p>
<p><span dir="rtl">هُنا يأتي تحذيرٌ آخر، فالبشر صنعوا جزءاً من شيطانِ وملاك</span></p>
<p><span dir="rtl">البعض يطغى عليه الجزء السيئ، لذا قد ينتهي بك المطاف تلتقي بهم</span></p>
<p><span dir="rtl">وتواجههم وترى الجحيم.</span></p><br/>
<p style="text-align:center; direction:ltr">It’s the same of “Doesn’t your mother told you don’t play with fire!”</p>
<p style="text-align:center; direction:ltr">Here comes the second warning, the human is made of half of the angel and the other half is Satan.</p>
<p style="text-align:center; direction:ltr">And some are totally controlled by the other half Satan, so you may end up meet them and face them so you may see hell.</p><br/>
<p><span dir="rtl">لذا تجاهل، وكُن حذراً.. اللعب دائماً لا يعني شيئاً جميلاً.</span></p><br/><br/>
<p style="text-align:center; direction:ltr">So, ignore them and be careful, playing does not always mean a beautiful thing.</p>
<br/><p style="text-align:center">******</p><br/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0009.vue?c1278134